import { useMemo } from 'react';
import { BudgetStatusEnum } from '../../../../enums/budgetStatus';
import { BudgetRecipientEnum } from '../../createAndEdit/types';

interface IUseConsultantDetailJourneyParams {
  userProfile?: BudgetRecipientEnum | string;
  budgetRecipient?: BudgetRecipientEnum | string;
  budgetStatus?: BudgetStatusEnum | string;
  isLastVersion?: boolean;
}

export const useConsultantDetailJourney = (params: IUseConsultantDetailJourneyParams) => {
  const { userProfile, budgetRecipient, budgetStatus, isLastVersion } = params;

  const isConsultant = userProfile === BudgetRecipientEnum.CONSULTANT;

  const isApproved = useMemo(() => {
    return budgetStatus === BudgetStatusEnum.APPROVED || budgetStatus === 'Aprovado';
  }, [budgetStatus]);

  const isRejected = useMemo(() => {
    return budgetStatus === BudgetStatusEnum.REJECTED || budgetStatus === 'Rejeitado';
  }, [budgetStatus]);

  const isPending = useMemo(() => {
    return budgetStatus === BudgetStatusEnum.PENDING || budgetStatus === 'Pendente';
  }, [budgetStatus]);

  // Consultant não pode enviar actions no modo detail
  const shouldShowActions = false;

  const shouldShowCloseButton = useMemo(() => {
    return isApproved || isRejected || isPending;
  }, [isApproved, isRejected, isPending]);

  const shouldShowCloseIcon = useMemo(() => {
    return !isApproved;
  }, [isApproved]);

  const shouldShowCounterProposal = useMemo(() => {
    return shouldShowActions;
  }, [shouldShowActions]);

  return {
    isConsultant,
    shouldShowActions,
    shouldShowCloseButton,
    shouldShowCloseIcon,
    shouldShowCounterProposal,
    isApproved,
  };
};
